var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',{staticStyle:{"background-color":"whitesmoke","overflow":"hidden"}},[_c('v-main',[_c('router-view'),_c('snackbar',{attrs:{"snackbar":_vm.getSnackbarStatus}})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }